import { Params, ParamMap } from '@angular/router';

const RWIC_KEY = 'rwic';
const FIELD_WORKER_KEY = 'fw';
const REVIEWER_KEY = 'rev';

export const toRwicParams = (args: { rwicId?: number }): Params => ({
	[RWIC_KEY]: args.rwicId ? args.rwicId : undefined,
});

export const toRwicListArgs = (paramMap: ParamMap): { rwicId?: number } =>
	paramMap.has(RWIC_KEY)
		? {
				rwicId: +paramMap.get(RWIC_KEY),
		  }
		: undefined;

export const toFieldWorkerParams = (args: {
	fieldWorkerId?: number;
}): Params => ({
	[FIELD_WORKER_KEY]: args.fieldWorkerId ? args.fieldWorkerId : undefined,
});

export const toFieldWorkerListArgs = (
	paramMap: ParamMap
): { fieldWorkerId?: number } =>
	paramMap.has(FIELD_WORKER_KEY)
		? {
				fieldWorkerId: +paramMap.get(FIELD_WORKER_KEY),
		  }
		: undefined;

export const toReviewerParams = (args: { reviewerId?: number }): Params => ({
	[REVIEWER_KEY]: args.reviewerId ? args.reviewerId : undefined,
});

export const toReviewerListArgs = (
	paramMap: ParamMap
): { reviewerId?: number } =>
	paramMap.has(REVIEWER_KEY)
		? {
				reviewerId: +paramMap.get(REVIEWER_KEY),
		  }
		: undefined;
